/* Sohi — header search overlay, THEME build.
   The demo's sohi-search.js filters window.SohiCatalog as you type; that
   catalog does not exist on Shopify, so this file drives the same overlay
   markup (snippets/sohi-search-overlay.liquid) over rows the server already
   rendered: every product in the range is in the DOM with a data-search-name,
   and typing simply shows the rows whose name contains the query. Same
   open/close contract, same result copy, same "first hit on Enter". */
(function () {
  "use strict";

  function init() {
    var overlay = document.querySelector("[data-search]");
    var input = document.querySelector("[data-search-input]");
    if (!overlay || !input) return;

    var hits = Array.prototype.slice.call(overlay.querySelectorAll(".search__hit"));
    var note = overlay.querySelector("[data-search-note]");
    var hitsWrap = overlay.querySelector("[data-search-hits]");
    var empty = overlay.querySelector("[data-search-empty]");
    var emptyNote = overlay.querySelector("[data-search-empty-note]");
    var lastFocused = null;
    var focusTimer = null;
    overlay.inert = !overlay.hasAttribute("data-open");

    function render(query) {
      var shown = 0;
      hits.forEach(function (hit) {
        var name = (hit.getAttribute("data-search-name") || hit.textContent).toLowerCase();
        var match = !query || name.indexOf(query) !== -1;
        hit.hidden = !match;
        hit.style.display = match ? "" : "none";
        if (match) shown++;
      });

      if (note) {
        note.textContent = query
          ? shown + (shown === 1 ? " result for “" : " results for “") + query + "”"
          : "All flavours";
        note.hidden = shown === 0;
      }
      if (hitsWrap) hitsWrap.hidden = shown === 0;
      if (empty) {
        empty.hidden = shown !== 0;
        if (emptyNote) emptyNote.textContent = "Nothing matches “" + query + "”.";
      }
    }

    function open(e) {
      if (e) e.preventDefault();
      if (overlay.hasAttribute("data-open")) return;
      lastFocused = document.activeElement;
      overlay.inert = false;
      overlay.setAttribute("data-open", "");
      render(input.value.trim().toLowerCase());
      // focus after the panel's transform transition has started, otherwise
      // iOS scrolls the page to a panel that is still off-screen
      focusTimer = window.setTimeout(function () {
        if (overlay.hasAttribute("data-open")) input.focus();
      }, 60);
    }
    function close() {
      if (!overlay.hasAttribute("data-open")) return;
      window.clearTimeout(focusTimer);
      overlay.removeAttribute("data-open");
      overlay.inert = true;
      if (lastFocused && document.contains(lastFocused)) lastFocused.focus();
      lastFocused = null;
    }

    document.querySelectorAll("[data-search-open]").forEach(function (btn) {
      btn.addEventListener("click", open);
    });
    overlay.querySelectorAll("[data-search-close]").forEach(function (el) {
      el.addEventListener("click", close);
    });
    document.addEventListener("keydown", function (e) {
      if (!overlay.hasAttribute("data-open")) return;
      if (e.key === "Escape") { close(); return; }
      if (e.key !== "Tab") return;
      var items = Array.prototype.filter.call(
        overlay.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), [tabindex]:not([tabindex="-1"])'),
        function (el) { return el.getClientRects().length > 0 && !el.closest("[hidden]"); }
      );
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    input.addEventListener("input", function () {
      render(input.value.trim().toLowerCase());
    });

    // With JS on, Enter opens the first visible hit — results are already
    // live below. With JS off the form posts to /search.
    var form = overlay.querySelector("[data-search-form]");
    if (form) {
      form.addEventListener("submit", function (e) {
        var first = hits.filter(function (h) { return !h.hidden; })[0];
        if (!first) return; // let /search handle a query nothing matched
        e.preventDefault();
        first.click();
      });
    }

    render("");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
